import {useQuery} from '@tanstack/react-query';

import {getParticipant} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';
import {Participant} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetParticipant = <SelectedData = Participant>(
  id: string,
  options?: QueryOptionsForOne<Participant, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__PARTICIPANTS, id],
    queryFn: () => getParticipant(id),
    ...options,
  });
};
